<h1  mat-dialog-title>{{data['name']}}</h1>
<div mat-dialog-content>
  <!--  <p>What's your favorite animal?</p>-->
  <!--  <mat-form-field>-->
  <!--    <input matInput [(ngModel)]="data.animal">-->
  <!--  </mat-form-field>-->
</div>
<div mat-dialog-actions *ngIf="!data['showCancel'] && !data['options']['showCancel']">
  <button class="buttonStart" style="width: 100% !important;" mat-button [mat-dialog-close]="data['name']" cdkFocusInitial>Ok</button>
</div>

<div mat-dialog-actions *ngIf="data['showCancel'] || data['options']['showCancel']">
  <button class="buttonStart" mat-button [mat-dialog-close]="data['name']">Yes</button>
  <button class="buttonStart" mat-button cdkFocusInitial (click)="onNoClick()">No</button>
</div>
